import HeroSection from './HeroSection';
import TeamShowcaseSection from './TeamShowcaseSection';
import CompetitionHighlightsSection from './CompetitionHighlightsSection';
import AchievementsSection from './AchievementsSection';
import PhotoGallerySection from './PhotoGallerySection';
import StatsSection from './StatsSection';

const Sports = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <HeroSection />
      <StatsSection />
      <CompetitionHighlightsSection />
      <TeamShowcaseSection />
      <AchievementsSection />
      <PhotoGallerySection />
    </div>
  );
};

export default Sports;
